import { gql } from '@apollo/client';

export const COMPANIES = gql`
    query companies(
        $search: String
        $status: [CompanyCompanyStatusChoices]
        $sort: CompanySortEnum
        $offset: Int
        $first: Int
    ) {
        companies(search: $search, status_In: $status, sort: $sort, offset: $offset, first: $first) {
            edges {
                node {
                    id
                    name
                    balance {
                        currency
                        amount
                    }
                    email
                    status
                    image {
                        url
                    }
                }
            }
            pageInfo {
                hasNextPage
            }
            totalCount
        }
    }
`;

export const COMPANY_BY_ID = gql`
    query company($id: ID!) {
        company(id: $id) {
            id
            companyId
            name
            phoneNumber
            address
            zipCode
            poBox
            uidNumber
            vatNumber
            membershipStart
            membershipEnd
            dateJoined
            leavingDate
            remainderBalance
            renewalFeeGross
            openMembershipInvoice {
                id
                invoiceId
            }
            balance {
                currency
                amount
            }
            email
            status
            city
            billToThisContact
            image {
                url
                alt
            }
            country {
                name
                code
            }
            members(first: 100) {
                edges {
                    node {
                        id
                        firstName
                        lastName
                        jobPosition
                        email
                        status
                        balance {
                            amount
                            currency
                        }
                        image {
                            url
                            alt
                        }
                    }
                }
            }
            contacts(first: 100) {
                edges {
                    node {
                        id
                        salutation
                        name
                        lastName
                        status
                        type
                        phoneNumber
                        secondaryPhoneNumber
                        email
                        secondaryEmail
                        address
                        zipCode
                        poBox
                        city
                        vatNumber
                        country {
                            name
                            code
                        }
                        billToThisContact
                        monthlyConsumptionOverview
                        receiveInvoiceCopy
                        relatedCompany {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
`;

export const COMPANY_INVOICES = gql`
    query companyInvoices(
        $company: ID!
        $status: [InvoiceStatus]
        $offset: Int
        $first: Int
        $sort: InvoiceSortEnum
        $search: String
    ) {
        invoices(company: $company, status_In: $status, offset: $offset, first: $first, sort: $sort, search: $search) {
            totalCount
            pageInfo {
                hasNextPage
            }
            edges {
                node {
                    id
                    invoiceId
                    status
                    dueDate
                    createdAt
                    type
                    lastReminder
                    member {
                        id
                        firstName
                        lastName
                    }
                    document {
                        url
                    }
                }
            }
        }
    }
`;

export const COMPANY_TRANSACTIONS = gql`
    query companyTransactions(
        $company: ID!
        $sort: TransactionSortEnum
        $first: Int
        $search: String
        $offset: Int
        $type: [TransactionType]
    ) {
        transactions(company: $company, sort: $sort, first: $first, search: $search, offset: $offset, type_In: $type) {
            totalCount
            pageInfo {
                hasNextPage
            }
            edges {
                node {
                    id
                    amount
                    currency
                    type
                    time
                    receiptNumber
                    paymentType
                    deductedFrom
                    member {
                        id
                        firstName
                        lastName
                    }
                }
            }
        }
    }
`;

export const COMPANY_MANUAL_TRANSACTIONS = gql`
    query companyManualTransactions(
        $company: ID!
        $sort: TransactionSortEnum
        $first: Int
        $search: String
        $offset: Int
        $type: [BalanceEntryType]
    ) {
        balanceEntries(company: $company, sort: $sort, first: $first, search: $search, offset: $offset, type_In: $type) {
            totalCount
            pageInfo {
                hasNextPage
            }
            edges {
                node {
                    id
                    amount
                    type
                    date
                    invoiceNumber
                    note
                    affectedBalance
                    member {
                        id
                        firstName
                        lastName
                    }
                }
            }
        }
    }
`;

export const COMPANIES_FULL = gql`
    query companies(
        $search: String
        $status: [CompanyCompanyStatusChoices]
        $sort: CompanySortEnum
        $offset: Int
        $first: Int
        $hasNegativeBalance: Boolean
        $hasRemainderBalance: Boolean
    ) {
        companies(
            search: $search
            status_In: $status
            sort: $sort
            offset: $offset
            first: $first
            hasNegativeBalance: $hasNegativeBalance
            hasRemainderBalance: $hasRemainderBalance
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    name
                    companyId
                    email
                    status
                    remainderBalance
                    balance {
                        currency
                        amount
                    }
                    image {
                        url
                        alt
                    }
                }
            }
        }
    }
`;

export const COMPANIES_BALANCES = gql`
    query companiesBalances(
        $status: [CompanyCompanyStatusChoices]
        $first: Int
        $offset: Int
    ) {
        companies(
            status_In: $status
            first: $first
            offset: $offset
        ) {
            totalCount
            pageInfo {
                hasNextPage
            }
            edges {
                node {
                    id
                    status
                    remainderBalance
                    balance {
                        currency
                        amount
                    }
                }
            }
        }
    }
`;
